var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider-block",style:(_vm.containerStyle)},[_c('div',{staticClass:"divider-line",style:(_vm.dividerStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }